import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";

export async function getWeekDataForTable(payload) {
    const requestObj = payload;
    try {
        return await authenticatedFetch(URL.manpowerShortage, {
            method: "POST",
            body: JSON.stringify(requestObj)
        });
    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
}
export async function getGraphData(payload) {
    const requestObj = payload;
    try {
        return await authenticatedFetch(URL.manpowerShortageGraph, {
            method: "POST",
            body: JSON.stringify(requestObj)
        });
    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
}
export async function getParameterData(payload) {
    const requestObj = payload;
    try {
        return await authenticatedFetch(URL.manpowerShortageParameter, {
            method: "POST",
            body: JSON.stringify(requestObj)
        });
    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
}